"use client";
import UnreadManager from "./UnreadManager";

export default function ClientProviders() {
    return <UnreadManager />;
}
